import { z } from 'zod';
/**
 * Phase 23 — mirrors the Prisma `AgreementType` / `AgreementTemplateStatus`
 * enums (docs/design/07-agreement-signing-gates.md). Facilities are out of
 * scope (operator-brokered FacilityContract instead of self-serve clickwrap).
 */
export const AgreementTypeSchema = z.enum(['CAREGIVER_IC', 'HOMECARE_CLIENT']);
export const AgreementTemplateStatusSchema = z.enum([
    'DRAFT',
    'ACTIVE',
    'DEPRECATED',
]);
//# sourceMappingURL=enums.schema.js.map